// tslint:disable: max-line-length
import React from "react"

export default function MoreVertical() {
  return (
    <symbol id="svg-more-vertical">
      <path
        id="Shape"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5888 24.8225C16.1649 24.8225 15 25.9874 15 27.4112C15 28.8351 16.1649 30 17.5888 30C19.0126 30 20.1775 28.8351 20.1775 27.4112C20.1775 25.9874 19.0126 24.8225 17.5888 24.8225ZM15 18.1888C15 16.765 16.1649 15.6 17.5888 15.6C19.0126 15.6 20.1775 16.765 20.1775 18.1888C20.1775 19.6126 19.0126 20.7776 17.5888 20.7776C16.1649 20.7776 15 19.6126 15 18.1888ZM20.1775 8.58879C20.1775 10.0126 19.0126 11.1776 17.5888 11.1776C16.1649 11.1776 15 10.0126 15 8.58879C15 7.16497 16.1649 6.00003 17.5888 6.00003C19.0126 6.00003 20.1775 7.16497 20.1775 8.58879Z"
        fill="currentColor"
      />
    </symbol>
  )
}
